module.exports = __webpack_public_path__ + "img/Avatar-28.11b7cf4a.svg";